export default __webpack_public_path__ + "static/media/fMaltoBuza18.138e052f.png";